import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GroupScType } from '../../models/SpecialConsideration';
import { GET_GSC_DOWNLOAD_TEMPLATE_URL } from '../../constants/apiUrls';
import { GET_GSC_DOWNLOAD_TEMPLATE_QUERY_KEY } from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface GetDownloadTemplateUrlResponse {
  url: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  groupScType: GroupScType;
  onSuccess?: (data: GetDownloadTemplateUrlResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetDownloadTemplateUrl = ({ groupScType, onSuccess, onError }: Input) => {
  const getDownloadTemplateUrl = async () => {
    const res = await axiosClient.get<GetDownloadTemplateUrlResponse>(
      GET_GSC_DOWNLOAD_TEMPLATE_URL(groupScType)
    );
    return res.data;
  };
  return useCustomQuery([GET_GSC_DOWNLOAD_TEMPLATE_QUERY_KEY], getDownloadTemplateUrl, {
    onSuccess,
    onError,
    enabled: false,
  });
};
